export const DEFAULT_COLUMN_SIZE = 150;

/**
 * Tooltip dwell inside a table, in ms. The app-wide delay is 0
 * (app-providers.tsx); a dense row grid is the one surface where instant
 * tooltips fire one per cell the pointer crosses, so every table root mounts
 * a TooltipProvider island at this value. 250 gates transit while Radix's
 * warm-up still shows neighbouring tips instantly once one is open, and it
 * sits under Radix's 300ms skip-delay window. Tune it here, nowhere else.
 *
 * One exception: `DirtyChangeTooltip` pins `delayDuration={0}` on its change
 * preview — only a cell the user just edited carries one, so there is no
 * transit to gate — while its fallback message keeps this dwell. It mirrors
 * Radix's open state only to lazy-mount its content, and `SequenceBox` only
 * prevents the close-on-activation default so the bubble survives the click —
 * everywhere else, WHEN to open belongs to the nearest provider.
 */
export const TABLE_TOOLTIP_DELAY_MS = 250;
